import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Autocomplete, TextField, Switch } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../core/BaseComponents/Modal";
// import { FaImage } from "react-icons/fa";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../utils/utils";
import { faImages } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteBackgroundImage from "./DeleteBackgroundImage";
import PreviewBgImage from "./PreviewBgImage ";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import EnableDisableHotelChannelsConfig from "./EnableDisableHotelChannelsConfig";
import { useSelector } from "react-redux";
import ImageResolutionTooltip from "../../ConfigurationNewHotel/ImageResolutionTooltip";

function HotelChannels() {
    const [hotelChannelsList, setHotelChannelsList] = useState([]);
    const [confirmDeleteHotelChannelsRow, setConfirmDeleteHotelChannelsRow] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [deleteHotelChannelsPopUp, setDeleteHotelChannelsPopUp] = useState(false);
    const [editHotelChannelsConfig, setEditHotelChannelsConfig] = useState(false);
    const [editHotelChannelsRowUpdate, setEditHotelChannelsRowUpdate] = useState(false);
    const [createHotelChannelsSuccessMsg, setCreateHotelChannelsSuccessMsg] = useState('');
    const [editHotelChannelsSid, setEditHotelChannelsSid] = useState("");
    const [loader, setLoader] = useState(false);
    const [fileError, setFileError] = useState("");
    const [files, setFiles] = useState('');
    const [fileUrl, setFileUrl] = useState('');
    const [resetData, setResetData] = useState({});
    // const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
    // const [flag, setFlag] = useState(false);
    const [showPreviewPopUp, setShowPreviewPopUp] = useState('');
    const [serviceidChannelnumList, setServiceidChannelnumList] = useState([]);
    const [showHintUrl, setShowHintUrl] = useState(false);

    // const [selectedPage, setSelectedPage] = useState(1);
    // const [totalPageCount, setTotalPageCount] = useState(1);
    // const [paginationError, setPaginationError] = useState("")
    // const [inputPageValue, setInputPageValue] = useState(1)

    const { chainId } = useSelector((state) => state.chainIdReducer);

    const recordsPerPage = 10;
    let selectionType = ["satellite", "internet"];
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
        watch,
        setValue
    } = useForm({
        mode: 'onChange',
        defaultValues: { active: true, selectionType: 'satellite' }
    });

    let validPermissionClassName = isValidRole("HOTEL_CHANNELS_MODIFY")
    ? ""
    : "btn-disable-permission";

    // const isPublishedUnPublishedRef = useRef({
    //     isPublishUnPublishModalData: null,
    // });

    const hotelChannelLogo = [
        {
          name: "Hotel Channel Logo",
          files: 1,
          size: "700 KB",
          height: "170 or larger",
          width: "170 or larger",
          resolution: "72 PPI",
          aspect: "1:01",
          formats: "JPG, JPEG, PNG",
        }
      ]

    const onSubmit = (data) => {
        if (fileUrl === '') {
            setFileError('Upload background image required');
            return;
        }
        if (fileError !== "") {
            return;
        }
        const formData = new FormData();
        formData.append('channelLogo', files);
        let method = "POST";
        let splitData = data?.serviceAndChannelId?.split(' : ');
        let url;
        if (data?.selectionType == 'satellite') {
            url = `/hotel-channel-default?channelName=${data?.channelName}&channelNumber=${splitData[1]}&serviceId=${splitData[0]}&selectionType=${data?.selectionType}&active=${data?.active}`;
        } else {
            url = `/hotel-channel-default?channelName=${data?.channelName}&selectionType=${data?.selectionType}&active=${data?.active}&url=${data?.url}`;
        }

        if (editHotelChannelsRowUpdate) {
            method = "PUT";
            if (data?.selectionType == 'satellite') {
                url = `/hotel-channel-default?sid=${editHotelChannelsSid?.sid}&active=${data?.active}&selectionType=${data?.selectionType}&channelName=${data?.channelName}&channelNumber=${splitData[1]}&serviceId=${splitData[0]}`;
            } else {
                url = `/hotel-channel-default?sid=${editHotelChannelsSid?.sid}&channelName=${data?.channelName}&selectionType=${data?.selectionType}&active=${data?.active}&url=${data?.url}`;
            }
        }

        callAPI(url, method, formData, { chainId: getChainIdLS() })
            .then(function (response) {
                setLoader(false);
                reset({
                    channelName: '',
                    selectionType: 'satellite',
                    serviceAndChannelId: '',
                    url: '',
                    active: true
                });
                setFileUrl('');
                setFiles('');
                setCreateHotelChannelsSuccessMsg(response?.message);
                hotelChannelsListApi();
                setEditHotelChannelsSid('');
                getHotelChannelForSatellite();
                setEditHotelChannelsConfig(false);
            })
            .catch(function (error) {
                setLoader(false);
                console.warn(error.response?.data?.errorMessage);
            });
    };

    const isHotelChannelsDeletedRef = useRef({
        isHotelChannelsDeletedModalData: null,
        userConformationModalData: null,
    });

    const deleteHotelChannelsConfigPopUpHandler = (row) => {
        setDeleteHotelChannelsPopUp(true);
        const newModalRefData = {
            isHotelChannelsDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isHotelChannelsDeletedRef.current = newModalRefData;
    }

    const deleteHotelChannelsHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteHotelChannelsRow === "") {
            return
        }

        if (confirmDeleteHotelChannelsRow === `Delete ${isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}`) {
            const { row } = isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData;
            setConfirmValidate(false);
            callAPI(`/hotel-channel-default?sid=${row?.sid}`, "DELETE")
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isHotelChannelsDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isHotelChannelsDeletedRef.current = newModalRefData;
                    hotelChannelsListApi();
                    getHotelChannelForSatellite();
                })
                .catch((error) => {
                    console.warn(error)
                });
        }
        reset({
            channelName: '',
            url: '',
            active: true,
            selectionType: 'satellite',
            serviceAndChannelId: '',
        });
        setFileUrl('');
        setFiles('');
    }

    // const publishUnPublishPopUpHandler = (row) => {
    //     setPublishUnPublishPopUp(true);
    //     const newModalRefData = {
    //         isPublishUnPublishModalData: {
    //             message: `Do you really want to ${row?.published ? 'Un-Publish' : 'Publish'} the Hotel channels Configuration?`,
    //             row
    //         }
    //     };
    //     isPublishedUnPublishedRef.current = newModalRefData;
    // }

    const renderActionIcon = (row) => {
        return (
            isValidRole("HOTEL_CHANNELS_MODIFY")?<>
                {!row?.isActive ? <>
                    <Tooltip title="Edit" arrow>
                        <MdModeEditOutline
                            className="edit-icon-enable"
                            onClick={() => { setEditHotelChannelsConfig(true); setEditHotelChannelsSid(row) }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete" className="cursor-pointer" arrow>
                        <DeleteIcon
                            className="delete-icon-enable"
                            onClick={() => {
                                deleteHotelChannelsConfigPopUpHandler(row);
                            }}
                        />
                    </Tooltip>
                </> : <>
                    <Tooltip title="Disable to perform actions">
                        <span>
                            <MdModeEditOutline className="edit-icon-disable" arrow />
                        </span>
                    </Tooltip>
                    <Tooltip title="Disable to perform actions">
                        <DeleteIcon className="delete-icon-disable" arrow />
                    </Tooltip>
                </>
                }
                {/* <Tooltip title={`${row?.published ? 'un-publish' : 'publish'}`} className="cursor-pointer" arrow>
                    <button type="button"
                        className={`ms-3 ${row?.published ? 'un-published' : 'published'}`}
                        onClick={() => publishUnPublishPopUpHandler(row)}
                    >
                        {row?.published ? 'Un-Publish' : 'Publish'}
                    </button>
                </Tooltip> */}

                <EnableDisableHotelChannelsConfig editHotelChannelsSid={editHotelChannelsSid?.sid} row={row} setLoader={setLoader} hotelChannelsListApi={hotelChannelsListApi} />
            </>
            :<>
            <Tooltip title="Don't have permission to edit">
                <span>
                    <MdModeEditOutline className="edit-icon-disable" arrow />
                </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete">
                <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
            <Tooltip title="Don't have permission to edit">
                <span>
                <Switch
                name="active"
                disabled={true}
                // onChange={(event) => handleToggleChange(event, props?.row)}
                inputProps={{ "aria-label": "controlled" }}
                value={row.isActive}
                checked={row.isActive}
                className={`${row.isActive === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                />
                </span>
        </Tooltip>
        </>
        );
    };

    const columns = [
        { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "selectionType", headerName: "Channel Type", flex: 1, row: true, renderCell: (row) => <p className="mb-0 text-capitalize">{row?.selectionType?.toLowerCase()}</p> },
        { field: "channelName", headerName: "Channel Name", flex: 1 },
        { field: "serviceId", headerName: "Service Id & Channel Number", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.serviceId && row?.channelNumber ? `${row?.serviceId} : ${row?.channelNumber}` : 'N.A'}</p> },
        {
            field: 'url', headerName: 'URL', flex: 1, row: true, renderCell: (row) => (
                row?.url ? <Tooltip title={row?.url}><a href={row?.url} target="_blank" rel="noopener noreferrer"
                    className={`text-black d-block ${row?.url?.length > 10 ? 'overflow-ellipsis-hotel-channels' : ''}`}>
                    {row?.url}</a></Tooltip> : 'N.A')
        },
        { field: 'channelLogo', headerName: 'Channel Logo', flex: 1, row: true, renderCell: (row) => (<img src={row?.channelLogo} alt={row?.sid} className="background-config-img" onClick={() => setShowPreviewPopUp(row?.channelLogo)} />), disableSortIcon: true, },
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    //Pagination Handle changer
    // const onPageChange = (event, value) => {
    //     setInputPageValue(value)
    //     setPaginationError("")
    //     setSelectedPage(value);
    // };

    const hotelChannelsListApi = () => {
        // const apiPath = `banner/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
        callAPI(`/hotel-channel-default/all`, "GET")
            .then((response) => {
                setHotelChannelsList(response);
                // setTotalPageCount(response?.totalPages ? response?.totalPages : 1);
                // setPaginationError("");
            })
            .catch((err) => console.warn(err.message));
    };

    useEffect(() => {
        hotelChannelsListApi();
        cancelHotelChannelsHandler()
    }, [chainId]);

    const popupCloseHandler = () => {
        setDeleteHotelChannelsPopUp(false);
    };


    useEffect(() => {
        if (editHotelChannelsConfig) {
            getHotelChannelsListSidHandler();
            // setEditHotelChannelsConfig(false);
        }
        ScrollToTop();
        setFileError('');
    }, [editHotelChannelsConfig]);

    const getHotelChannelsListSidHandler = () => {
        callAPI(`/hotel-channel-default?sid=${editHotelChannelsSid?.sid}`, "GET")
            .then(function (response) {
                const payload = {
                    channelName: response?.channelName,
                    url: response?.url,
                    selectionType: response?.selectionType?.toLowerCase(),
                    serviceAndChannelId: `${response?.serviceId} : ${response?.channelNumber}`,
                    active: response?.isActive
                };
                setFileUrl(response?.channelLogo);
                reset(payload);
                setResetData(response?.channelLogo)
                setEditHotelChannelsRowUpdate(true);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }

    const resetLayoutHandler = () => {
        reset();
        setFileUrl(resetData);
        setFileError('');
    }

    const cancelHotelChannelsHandler = () => {
        reset({
            channelName: '',
            url: '',
            active: true,
            selectionType: 'satellite',
            serviceAndChannelId: ''
        });
        setFileUrl('');
        setFiles('');
        setEditHotelChannelsRowUpdate(false);
        setEditHotelChannelsSid('');
        setEditHotelChannelsConfig(false);
    }

    const uploadOrDragFileHandler = (fileList) => {
        let bytes = (fileList.size / 1024).toFixed(2);
        setFileUrl(URL.createObjectURL(fileList));
        if (bytes > 700) {
            setFileError('Upload file should be less than 700KB');
            return;
        }
        setFiles(fileList);
        setFileError('');
    }
    const deleteLogoHandler = () => {
        setFiles('');
        setFileUrl('');
        setFileError('');
    };

    const handleSwitchChange = (checked) => {
        setValue("active", checked);
    };

    const getHotelChannelForSatellite = () => {
        callAPI(`/hotel-channel-default/getDefaultHotelChannelForSatellite`, "GET", {}, { chainId: getChainIdLS() })
            .then(function (response) {
                setServiceidChannelnumList(response.map((item => `${item?.serviceId} : ${item?.channelNumber}`)))
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }
    useEffect(() => {
        if (watch('selectionType') == 'satellite') {
            getHotelChannelForSatellite()
        }
    }, [watch('selectionType'), chainId])

    return (
        <div className='row config-hotel config-management-form'>
            <div className='col-12 left-column'>
                {loader && <div className="circular-progress"><CircularProgress /></div>}
                <form autoComplete="off" className={`hotel-list-form`}>
                {/* {hotelChannelsList?.length>0 && !editHotelChannelsConfig && <div className='mask-content default-config'>Only one default configuration can be created at a time. <br/> Please update existing one if required.</div> } */}
                    <div className="row">
                        <div className="left-column-header">
                            <p className="Roboto-Bold">{editHotelChannelsRowUpdate ? 'Edit Hotel Channel' : 'Hotel Channel'} Configuration</p>
                        </div>

                        <div className="col-6">
                            <div className="form-group-hotel">
                                <div className="floating-select-label">
                                    <Controller
                                        name="selectionType"
                                        control={control}
                                        rules={{
                                            validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select selection type',
                                        }}
                                        render={({ field }) => (
                                            <Autocomplete
                                                {...field}
                                                className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                                disablePortal
                                                options={selectionType}
                                                disabled={editHotelChannelsRowUpdate}
                                                getOptionLabel={(option) => option}
                                                onChange={(_, newValue) => {
                                                    field.onChange(newValue);
                                                }}
                                                value={field.value || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder=""
                                                        variant="outlined"
                                                        label="Type Of Channel"
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </div>
                                {errors.selectionType && (
                                    <small className="required">{errors.selectionType?.message}</small>
                                )}
                            </div>
                            <div className="form-group-hotel">
                                <div className="floating-label">
                                    {/* <FaImage className="new-hotel-icons" /> */}
                                    <input
                                        id="channelName"
                                        maxLength={30}
                                        placeholder=""
                                        {...register("channelName", {
                                            required: "Channel Name Required",
                                            pattern: {
                                                value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                                                message: "Only alphanumeric characters and single spaces between words are allowed",
                                            },
                                        })}
                                    />
                                    <label htmlFor="channelName">Channel Name</label>
                                </div>
                                {errors.channelName && (
                                    <small className="required">{errors.channelName.message}</small>
                                )}
                            </div>
                            {watch('selectionType') == "satellite" ?
                                <div className="form-group-hotel">
                                    <div className="floating-select-label">
                                        <Controller
                                            name="serviceAndChannelId"
                                            control={control}
                                            rules={{
                                                validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please Select Service ID : Channel Number',
                                            }}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                                    disablePortal
                                                    options={serviceidChannelnumList}
                                                    getOptionLabel={(option) => option}
                                                    onChange={(_, newValue) => {
                                                        field.onChange(newValue);
                                                    }}
                                                    value={field.value || ''}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder=""
                                                            variant="outlined"
                                                            label="Service ID : Channel Number"
                                                            InputLabelProps={{
                                                                shrink: false,
                                                            }}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </div>
                                    {errors.serviceAndChannelId && (
                                        <small className="required">{errors.serviceAndChannelId?.message}</small>
                                    )}
                                </div>
                                : <div className="form-group-hotel">
                                    <div className="floating-label">
                                        {/* <FaImage className="new-hotel-icons" /> */}
                                        <input
                                            id="url"
                                            // maxLength={255}
                                            placeholder="" 
                                            {...register("url", {
                                                required: "URL Required",
                                                pattern: {
                                                    value: /^(http|https):\/\/.*\.(mp4|mpd|m3u8)$/,
                                                    message: "URL must start with http:// or https:// and end with .mp4 or .m3u8 or .mpd",
                                                },
                                                maxLength: {
                                                    value: 255,
                                                    message: "Maximum 255 charaters allowed for URLs",
                                                },
                                            })}
                                            onBlur={() => setShowHintUrl(false)}
                                            onFocus={() => setShowHintUrl(true)}
                                        />
                                        <label htmlFor="URL">URL</label>
                                    </div>
                                    {errors.url && (
                                        <small className="required">{errors.url.message}</small>
                                    )}
                                    {showHintUrl && (<p className="hint-text">URLs should be non-encrypted and non tokenized</p>)}
                                </div>}
                            <div className="status-switch">
                                <p className="mb-0">Hotel Channel Status</p>
                                <label htmlFor="active">{!watch("active") ? "Disabled" : "Enabled"}</label>
                                <Switch
                                    id="active"
                                    className={`form-control border-0 ${!watch("active")
                                        ? "switchuser-inactive"
                                        : "switchuser-active"
                                        }`}
                                    checked={watch("active")}
                                    onChange={handleSwitchChange}
                                    {...register("active")}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="col-12">
                                {fileUrl !== "" ? <div className="partner-logo">
                                    <img src={fileUrl} alt={fileUrl} />
                                    <span onClick={() => deleteLogoHandler()}>X</span>
                                </div>
                                    : <FileUploader
                                        name="file"
                                        types={["JPG", "PNG", 'JPEG']}
                                        handleChange={uploadOrDragFileHandler}
                                        classes="drag-file file-upload-bg"
                                        children={
                                            <>
                                                <FontAwesomeIcon icon={faImages} className="fa-lg" />
                                                <p className="drag-text">
                                                    Drag and drop logo or
                                                    <span> Browse</span>
                                                    <br />
                                                    To upload <span className="Roboto-Bold text-black">Hotel Channel logo</span> here.<ImageResolutionTooltip data={hotelChannelLogo}/>
                                                </p>
                                                {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                                            </>
                                        }
                                    />
                                }

                                {fileError && <p className="required">{fileError}</p>}
                            </div>
                        </div>

                    </div>
                    <div className="text-end mt-3">
                        <button type="button" className="clear-btn me-2" onClick={cancelHotelChannelsHandler}>{editHotelChannelsRowUpdate ? "Cancel" : "Clear All"}</button>
                        {editHotelChannelsRowUpdate && <>
                            <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                        </>}
                        {/* {!editHotelChannelsRowUpdate && <button type="button" onClick={handleSubmit(onSave)} className="disable-btn me-2">Save</button>} */}
                        <button type="button" onClick={handleSubmit(onSubmit)} className={`create-btn ${validPermissionClassName} `}>{editHotelChannelsRowUpdate ? "Update" : "Create"}</button>
                    </div>
                </form>
                <div className="hotel-list">
                    <p><b>Hotel Channels List</b></p>

                    <TableWrapper
                        data={hotelChannelsList}
                        columns={columns}
                        noPagination={true}
                        module="partner-config"
                    />
                    {/* <Custom_Paingation
                        selectedPage={selectedPage}
                        totalPageCount={totalPageCount}
                        paginationError={paginationError}
                        inputPageValue={inputPageValue}
                        setSelectedPage={setSelectedPage}
                        setPaginationError={setPaginationError}
                        setInputPageValue={setInputPageValue}
                        onPageChange={onPageChange}
                    /> */}
                </div>
            </div>
            {deleteHotelChannelsPopUp && <DeleteBackgroundImage
                deleteHotelChannelsPopUp={deleteHotelChannelsPopUp}
                isHotelChannelsDeletedRef={isHotelChannelsDeletedRef}
                popupCloseHandler={popupCloseHandler}
                deleteHotelChannelsHandler={deleteHotelChannelsHandler}
                setConfirmDeleteHotelChannelsRow={setConfirmDeleteHotelChannelsRow}
                confirmDeleteHotelChannelsRow={confirmDeleteHotelChannelsRow}
                confirmValidate={confirmValidate}
            />}
            <BasicModal
                popupOpen={createHotelChannelsSuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{createHotelChannelsSuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setCreateHotelChannelsSuccessMsg(''); setEditHotelChannelsRowUpdate(false); hotelChannelsListApi(); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            {showPreviewPopUp !== "" && <PreviewBgImage
                showPreviewPopUp={showPreviewPopUp}
                setShowPreviewPopUp={setShowPreviewPopUp}
            />}
            {/* <BasicModal
                popupOpen={publishUnPublishPopUp}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<>
                    {isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData && <p className="mt-2">{isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message}</p>}
                </>
                }
                footer={
                    isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Publish the Hotel channels?" ||
                        isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Un-Publish the Hotel channels?" ? {
                        primaryButton: {
                            buttonName: "Cancel",
                            action: () => setPublishUnPublishPopUp(false)
                        },
                        secondaryButton: {
                            buttonName: isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.published ? 'Un-Publish' : 'Publish',
                            action: publishUnPublishHandler
                        }
                    } : {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => setPublishUnPublishPopUp(false)
                        }
                    }
                }
            /> */}
        </div>
    )
}

export default HotelChannels;